<template>
  <div class="auth-container">
    <img src="@/assets/RiskyPawsLogo.png" alt="RiskyPaws Logo" class="logo" />
    <h2 v-if="!verificationStep">
      {{ isLogin ? 'Login to RiskyPaws: Your Financial Companion' : 'Sign Up for RiskyPaws: Your Financial Companion' }}
    </h2>
    <!-- Only show the sign up/login form if NOT in the verification step -->
    <form @submit.prevent="authenticate" v-if="!verificationStep">
      <input class="auth-input" type="text" v-model="username" placeholder="Email (used as username)" required />
      <input class="auth-input" type="password" v-model="password" placeholder="Password" required />
      <div v-if="!isLogin">
        <!-- Show these fields only when signing up and not in verification step -->
        <input class="auth-input" type="email" v-model="email" placeholder="Confirm Email" required />
        <input class="auth-input" type="text" v-model="name" placeholder="Full Name" required />
        <input class="auth-input" type="tel" v-model="formattedPhoneNumber" placeholder="Phone Number" required />
      </div>
      <button class="auth-button" type="submit">{{ isLogin ? 'Login' : 'Sign Up' }}</button>
      <button class="toggle-button" @click="toggle">{{ isLogin ? 'Need to create an account?' : 'Have an account?' }}</button>
    </form>

    <!-- Verification step -->
    <div v-if="verificationStep">
      <input class="auth-input" type="text" v-model="username" placeholder="Email (used as username)" required />
      <input class="auth-input" type="text" v-model="verificationCode" placeholder="Verification Code" required />
      <button class="auth-button" @click="verify">Verify Account</button>
    </div>
    <p v-if="error" class="error-message">{{ error }}</p>
    <p v-if="verificationMessage" class="success-message">{{ verificationMessage }}</p>
    <p class="acknowledgment" style="text-align: center; font-size: 14px; color: black;">
      This financial literacy platform is for educational purposes only. It does not offer any financial advice. Please consult with your licensed financial advisor or broker for personalized advice.
    
      By using this website, you acknowledge the above disclaimer.
    </p>
  </div>



   
  
   
</template>


<script>
import { Auth } from 'aws-amplify';
import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';

export default {
data() {
  return {
    isLogin: true,
    username: '',
    password: '',
    name: '', // Full name for sign-up
    phoneNumber: '', // Phone number for sign-up, initially empty
    email: '', // Email for sign-up
    verificationStep: false,
    verificationCode: '',
    error: '',
    verificationMessage: '',
  };
},
computed: {
  formattedPhoneNumber: {
    get() {
      // Add the +1 prefix if it's not present
      if (this.phoneNumber.startsWith('+1')) {
        return this.phoneNumber;
      } else if (this.phoneNumber.startsWith('1')) {
        return `+${this.phoneNumber}`;
      } else if (this.phoneNumber && !this.phoneNumber.startsWith('+')) {
        return `+1${this.phoneNumber}`;
      }
      return '+1';
    },
    set(value) {
      // Strip out any non-numeric characters and ensure correct format
      const rawNumber = value.replace(/[^\d]/g, '');
      this.phoneNumber = rawNumber.startsWith('1') ? `+${rawNumber}` : rawNumber;
    }
  }
},
methods: {
  toggle() {
    this.isLogin = !this.isLogin;
    this.error = ''; // Clear the error when toggling between login/sign up
  },
 async authenticate() {
    try {
        if (this.isLogin) {
            // Authenticate with Cognito
            await Auth.signIn(this.username, this.password);
            const session = await Auth.currentSession();
            const accessToken = session.getAccessToken().getJwtToken(); 
            this.$router.push('/dashboard');
            // Send Cognito access token to Django
            const djangoResponse = await axios.post('https://api.riskypaws.com/api/signin/', {
                token: accessToken,
          });

          const djangoToken = djangoResponse.data.token;
          sessionStorage.setItem('djangoToken', djangoToken);
          sessionStorage.setItem('authToken', accessToken);

          console.log('Logged in with token:', accessToken);
          this.$router.push('/');
    } else {
          // Sign-up logic
          const user = await Auth.signUp({
            username: this.username,
            password: this.password,
            attributes: {
              email: this.email,
              name: this.name,
              phone_number: this.formattedPhoneNumber,
            },
          });
          console.log('Signed up:', user);
          this.verificationStep = true;
          // Clear form and show a message to check for verification
          this.username = '';
          this.password = '';
          this.email = '';
          this.name = '';
          this.phoneNumber = '';
          this.error = '';
          this.verificationMessage = 'A verification code has been sent to your email. Please enter it below to verify your account.';
        }
      } catch (error) {
        console.error(error);
        this.error = error.message || "An unexpected error occurred";
      }
    },
    async verify() {
      try {
        const data = await Auth.confirmSignUp(this.username, this.verificationCode);
        console.log('Verification successful:', data);
        this.verificationMessage = 'Verification successful. Please log in.';
        this.verificationStep = false;
        this.isLogin = true;
        this.username = '';
        this.password = '';
      
        this.$router.push('/login'); 
      } catch (err) {
        console.error(err);
        this.error = err.message || "Verification failed";
      }
    },
    // ... other methods
  }
};
</script>



<style scoped>
.auth-container {
  width: 350px;
  margin: auto;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  background-color: #C9B6D9 ;
  text-align: center;
}

.auth-input {
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.auth-button, .toggle-button, .google-button {
  width: calc(100% - 20px);
  padding: 12px;
  border: none;
  border-radius: 5px;
  margin-bottom: 20px;
  cursor: pointer;
  font-size: 16px;
}

.auth-button {
  background-color: #4A148C;
  color: white;
}

.toggle-button {
  background-color: #e0e0e0;
}

.google-button {
  background-color: #dd4b39;
  color: white;
}

.error-message {
  color: red;
  margin-bottom: 20px;
}

.logo {
  width: 300px; 
  margin: 5px auto 10px;
  display: block;
}

.success-message {
  color: green;
  margin-bottom: 20px;
}

.amazon-button {
background-color: #4A148C;
color: white;
}

.acknowledgment {
    text-align: center;
    font-size: 12px;
    color: #666;
    margin-top: 10px; 
    font: nunito;
  }

@media (max-width: 600px) {
  .auth-container {
    width: 90%;
    padding: 10px;
  }
  .logo {
    width: 80%;
  }
  /* Other styles for smaller screens */
}
</style>
